import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RedirectWhatsappPageRoutingModule } from './redirect-whatsapp-routing.module';

import { RedirectWhatsappPage } from './redirect-whatsapp.page';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    RedirectWhatsappPageRoutingModule
],
  declarations: [RedirectWhatsappPage]
})
export class RedirectWhatsappPageModule {}
